import { VIEW } from "@chef/constants";
import type { View } from "@chef/types/common";

export const isDeviationView = (view?: View): view is "deviation" =>
  view === VIEW.DEVIATION;

export const isConversionView = (view?: View): view is "conversion" =>
  view === VIEW.CONVERSION;

export const isHistoricView = (view?: View): view is "historic" =>
  view === VIEW.HISTORIC;
